import {
    ChangeDetectionStrategy,
    Component,
    computed,
    ElementRef,
    inject,
    input,
    Input,
    output,
    signal,
    ViewEncapsulation,
} from '@angular/core';
import { FiTooltipContentType } from 'Source/app/shared/fi-tooltip/fi-tooltip-enums';
import { FileType } from 'Source/app/shared/types';
import { getAcceptByFileType } from 'Source/app/shared/utils/get-accept-by-file-type';
import { IInsertMediaResult } from 'Source/app/shared/fi-insert-media/fi-insert-media';
import { FiInsertMedia2Service } from 'Source/app/shared/fi-insert-media/fi-insert-media2.service';
import { Observable, Subject } from 'rxjs';
import { FiDndDetails, FiDndEventType } from '@fi-shared/fi-insert-media/fi-dnd-overlay/fi-dnd-helper';
import { FiFileUploadHelperService } from '@fi-shared/fi-insert-media/fi-file-upload-helper.service';

@Component({
    selector: 'fi-file-upload-placeholder',
    templateUrl: './fi-file-upload-placeholder.component.html',
    styleUrl: './fi-file-upload-placeholder.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-file-upload-placeholder' },
    standalone: false,
})
export class FiFileUploadPlaceholderComponent {
    @Input() fileUploadHintTextId: string = 'media.click_or_dnd_to_upload_hint';
    @Input() multiple = false;
    @Input() iconsSize: number = 65;
    @Input() wrapperElementRef: ElementRef;
    allowedFileTypes = input<FileType[]>();

    filesInsertedFromPopup = output<IInsertMediaResult>();
    filesInsertedViaDnd = output<File[]>();

    protected fiInsertMedia2Service = inject(FiInsertMedia2Service);
    protected fiFileUploadHelperService = inject(FiFileUploadHelperService);
    protected elementRef = inject(ElementRef<HTMLElement>);

    private _showInsertFileErrorTooltip$ = new Subject<void>();
    protected get showInsertFileErrorTooltip$(): Observable<void> {
        return this._showInsertFileErrorTooltip$.asObservable();
    }

    protected onInsertFileFromPopupClick() {
        // upload after selecting from attachment popup
        this.fiInsertMedia2Service
            .openInsertMediaDialog({
                multiple: this.multiple,
                accept: getAcceptByFileType(this.allowedFileTypes(), undefined),
                fileTypes: this.allowedFileTypes(),
                allowStoreInMyFiles: false,
            })
            .onYesButtonClick((result: IInsertMediaResult) => {
                this.filesInsertedFromPopup.emit(result);
            });
    }

    protected onFilesInsertedViaDnd($event: File[]) {
        this.filesInsertedViaDnd.emit($event);
    }

    protected isDragOver = signal(false);

    protected onDndDetails($event: FiDndDetails) {
        this.setIsDragOver($event.dndEventType);

        if ($event.dndEventType === FiDndEventType.DragEnter && !$event.isDndAllowed) {
            this._showInsertFileErrorTooltip$.next();
        }
    }

    private readonly dragOverEventTypes: readonly FiDndEventType[] = [
        FiDndEventType.DragEnter,
        FiDndEventType.DragOver,
    ];

    private setIsDragOver(fiDndEventType: FiDndEventType) {
        this.isDragOver.set(this.dragOverEventTypes.includes(fiDndEventType));
    }

    protected getInsertFileErrorContentText = computed<string>(() => {
        return this.fiFileUploadHelperService.getInsertFileErrorContentText(this.allowedFileTypes());
    });

    /*protected getInsertFileErrorContentText(): string {
        // bad approach, is invoked constantly
        return this.fiFileUploadHelperService.getInsertFileErrorContentText(this.allowedFileTypes);
    }*/

    protected readonly FiTooltipContentType = FiTooltipContentType;
}
